type AuthKey =
  | 'accessToken'
  | 'refreshToken'
  | 'userId'
  | 'userEmail'
  | 'userName';

const AUTH_KEYS: AuthKey[] = [
  'accessToken',
  'refreshToken',
  'userId',
  'userEmail',
  'userName',
];

const LEGACY_STORAGE_KEYS = ['userBalance'];

const safeGet = (storage: Storage, key: string): string | null => {
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
};

const safeSet = (storage: Storage, key: string, value: string): void => {
  try {
    storage.setItem(key, value);
  } catch {
    // Ignore storage write failures.
  }
};

const safeRemove = (storage: Storage, key: string): void => {
  try {
    storage.removeItem(key);
  } catch {
    // Ignore storage removal failures.
  }
};

export const getAuthItem = (key: AuthKey): string => {
  const sessionValue = safeGet(sessionStorage, key);
  if (sessionValue !== null) {
    return sessionValue;
  }

  const legacyValue = safeGet(localStorage, key);
  if (legacyValue !== null) {
    safeSet(sessionStorage, key, legacyValue);
    safeRemove(localStorage, key);
    return legacyValue;
  }

  return '';
};

export const getAuthToken = (): string => getAuthItem('accessToken');

export const setAuthSession = (
  session: Partial<Record<AuthKey, string | number>>
): void => {
  AUTH_KEYS.forEach((key) => {
    const value = session[key];
    if (value !== undefined) {
      safeSet(sessionStorage, key, String(value));
      safeRemove(localStorage, key);
    }
  });

  LEGACY_STORAGE_KEYS.forEach((key) => {
    safeRemove(sessionStorage, key);
    safeRemove(localStorage, key);
  });
};

export const clearAuthSession = (): void => {
  AUTH_KEYS.forEach((key) => {
    safeRemove(sessionStorage, key);
    safeRemove(localStorage, key);
  });

  LEGACY_STORAGE_KEYS.forEach((key) => {
    safeRemove(sessionStorage, key);
    safeRemove(localStorage, key);
  });

  safeRemove(localStorage, 'token');
  safeRemove(sessionStorage, 'token');
};

export const isAuthenticated = (): boolean => getAuthToken().trim().length > 0;
